import type { ReactElement } from 'react';

import { AccountSection } from '../components/features/settings/AccountSection.js';
import { ChildrenSection } from '../components/features/settings/ChildrenSection.js';
import { FamilySection } from '../components/features/settings/FamilySection.js';
import { MembersSection } from '../components/features/settings/MembersSection.js';
import { ApiStatusCard } from '../components/features/system/ApiStatusCard.js';
import { InstallCard } from '../components/features/system/InstallCard.js';
import { PageHeader } from '../components/layout/PageHeader.js';
import { SelectField } from '../components/ui/SelectField.js';
import { Spinner } from '../components/ui/Spinner.js';
import { useActiveFamily } from '../hooks/useActiveFamily.js';

export function SettingsPage(): ReactElement {
    const { me, families, active, setActiveFamilyId } = useActiveFamily();
    const isOwner = active?.role === 'owner';

    return (
        <>
            <PageHeader title="Settings" />
            {me.isPending || !active ? <Spinner label="Loading settings" /> : null}
            {active ? (
                <>
                    {families.length > 1 ? (
                        <SelectField
                            label="Active family"
                            options={families.map((family) => ({
                                value: family.id,
                                label: family.name,
                            }))}
                            value={active.id}
                            onChange={(event) => {
                                setActiveFamilyId(event.target.value);
                            }}
                        />
                    ) : null}
                    <FamilySection familyId={active.id} canEdit={isOwner} />
                    <ChildrenSection familyId={active.id} canEdit={isOwner} />
                    <MembersSection
                        familyId={active.id}
                        canManage={isOwner}
                        currentUserId={me.data?.user.id ?? ''}
                    />
                </>
            ) : null}
            <AccountSection />
            <InstallCard />
            <ApiStatusCard />
        </>
    );
}
